import { TwoFaActionWizard } from 'modules/components';
import { useDispatch } from 'modules/react-redux';
import { LOGIN_PAGE_ID } from 'pages/auth/config';
import { FC, memo, useCallback } from 'react';

import { finishTwoFaLogin, sendTwoFaLoginEmailCode, showLoginModule } from '../../actions';
import { messages } from './TwoFaLoginModule.messages';
import { TwoFaLoginModuleProps } from './TwoFaLoginModule.types';

/**
 * @deprecated Use Redesigned version
 */
const TwoFaLoginModule: FC<TwoFaLoginModuleProps> = memo((props) => {
    const { isTrustThisDeviceEnabled, isTFAAlternativeEmailEnabled, isTFABackupCodesEnabled } = props;

    const dispatch = useDispatch();

    const onEnterCode = useCallback(
        async (userCode: string, trustThisDevice = false) => {
            await dispatch(finishTwoFaLogin(userCode, trustThisDevice));
        },
        [dispatch]
    );

    const onSendCodeViaEmail = useCallback(async () => {
        await dispatch(sendTwoFaLoginEmailCode());
    }, [dispatch]);

    const onClose = useCallback(() => {
        dispatch(
            showLoginModule({
                innerPageId: LOGIN_PAGE_ID,
            })
        );
    }, [dispatch]);

    return (
        <TwoFaActionWizard
            title={messages.title}
            open
            onEnterAppCode={onEnterCode}
            onEnterBackupCode={onEnterCode}
            onEnterEmailCode={onEnterCode}
            onSendCodeViaEmail={onSendCodeViaEmail}
            isTFAAlternativeEmailEnabled={isTFAAlternativeEmailEnabled}
            isTFABackupCodesEnabled={isTFABackupCodesEnabled}
            isTrustThisDeviceEnabled={isTrustThisDeviceEnabled}
            onClose={onClose}
            disableAutoClose
        />
    );
});

export default TwoFaLoginModule;
